import { useState } from 'react';
import ResetPasswordForm from '../forms/ResetPassword';
import ConfirmPassForm from '../forms/ConfirmPass';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../Assets/AuthLayout';
import { PrimaryBtn } from '../Assets/Buttons';
import { useResetPasswordMutation, useConfirmPassResetMutation } from '../../services/api/userApi';

const ResetPassPage = () => {
    const [resetPassword, { data: resetPasswordData, isLoading: isResetPasswordLoading, isError: isResetPasswordError, error: resetPasswordError }] = useResetPasswordMutation();
    const [confirmPassReset, { data: confirmPassResetData, isLoading: isConfirmPassResetLoading, isError: isConfirmPassResetError, error: confirmPassResetError }] = useConfirmPassResetMutation();
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [err, setErr] = useState('');
    const [code, setCode] = useState('');
    const [newPass, setNewPass] = useState('');
    const [confPass, setConfPass] = useState('');

    const handleSendCode = async() => {
        // body of post request
        const body = {
            email: email
        };

        try{
            await resetPassword(body).unwrap();
            setStep(2);
        } catch (error) {
            if (error.data.error.includes("LimitExceededException")) {
                setErr('You have attemped to reset your password too many times, please wait and try again later.')
            } else if (error.data.error.includes("InternalErrorException")) {
                setErr("Something went wrong on our end. Please try again later.")
            } else {
                console.log(error);
                setErr("Something went wrong, please try again in a few minutes");
            }
        }
    };

    const handleConfPass = async() => {
        // body of post request
        const body = {
            email: email, 
            pass: newPass,
            code:code
        };

        try {
            await confirmPassReset(body).unwrap();
            setStep(3);
        } catch (error) {
            console.log(error);
            if (error.data.error.includes("CodeMismatchException") || error.data.error.includes("ExpiredCodeException")) {
                setErr('The reset code you entered is incorrect or has already been used. Please request a new one if needed.')
            } else if (error.data.error.includes("InternalErrorException")) {
                setErr("Something went wrong on our end. Please try again later.")
            }else if(error.data.error.includes("InvalidPasswordException") || error.data.error.includes("UserNotFoundException")){
                setErr("We were unable to reset your password. Please ensure you've entered the new password and that it meets our criteria. If you continue to experience issues, please contact our support team.");
            }else{
                console.log(error);
                setErr("Something went wrong, please try again in a few minutes");
            };
        };
    };

    return (
        <AuthLayout>
            <div className="w-full max-w-sm h-full">
                {step === 1 && (
                    <>
                        <div className="mb-6 text-center">
                            <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Reset Your Password</h2>
                            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                                    We will send you an email containing a code to complete this process.
                            </p>
                        </div>
                        <ResetPasswordForm
                            err={err}
                            navigate={navigate}
                            email={email}
                            setEmail={setEmail}
                            setStep={setStep}
                            handleSubmit={handleSendCode}
                        />
                    </>
                )}
                {step === 2 && (
                    <>
                        <div className="mb-6 text-center">
                            <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Change Your Password</h2>
                            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                                    If there is an account under the provided email, you should receive a code to reset your password.
                            </p>
                        </div>
                        <ConfirmPassForm 
                            navigate={navigate} 
                            email={email} 
                            err={err} 
                            setStep={setStep} 
                            handleSubmit={handleConfPass}
                            code={code} 
                            setCode={setCode}
                            newPass={newPass} 
                            setNewPass={setNewPass}
                            confPass={confPass} 
                            setConfPass={setConfPass}
                        />
                    </>
                )}
                {step === 3 && (
                    <div className="text-center">
                        <div className="mb-6">
                            <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Password Reset</h2>
                            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                                    Your password has been reset successfully.
                            </p>
                        </div>
                        <PrimaryBtn 
                            text="Return to Sign In" 
                            onClick={() => navigate('/signin')} 
                            className="w-full"
                        />
                    </div>
                )}
            </div>
        </AuthLayout>
    );
};

export default ResetPassPage;